/* Matratzen-Finder — quiz flow, scoring and soft email gate.
   Markup lives in sections/custom-mattress-finder.liquid; one hidden
   .mf-card per model carries the live product data. The email form is a
   native Shopify customer form (full page POST); quiz state survives the
   round-trip in localStorage and is restored via the ?mf=subscribed
   return_to parameter. */
(function () {
  'use strict';

  var STORAGE_KEY = 'dc-mattress-finder';
  var STEPS = ['who', 'position', 'feel', 'complaints', 'budget'];

  /* Answer -> model weights. Positive numbers recommend, negative
     numbers push a model out of a budget band. Model keys must match
     data-mf-model on the hidden cards. */
  var WEIGHTS = {
    who: {
      zwei: { wellness: 2 }
    },
    position: {
      seite: { premium_plus: 3, thermogel_air: 2, premium: 1 },
      ruecken: { premium: 3, premium_plus: 2, fit: 1 },
      bauch: { fit: 3, premium: 2 },
      wechselnd: { premium: 2, wellness: 2, thermogel_air: 1 }
    },
    feel: {
      weich: { aqua: 3, premium_plus: 2 },
      mittel: { premium: 2, thermogel_air: 2, wellness: 1 },
      fest: { fit: 3, premium: 1 },
      unsicher: { wellness: 3, premium: 1 }
    },
    complaints: {
      ruecken: { premium: 2, premium_plus: 1, fit: 1 },
      druck: { premium_plus: 3, thermogel_air: 2, aqua: 1 },
      schwitzen: { thermogel_air: 3, polargel: 2, wellness: 2 },
      partner: { premium_plus: 1, thermogel_air: 1 }
    },
    budget: {
      bis700: { ortho: 4, wellness: 1, aqua: 1, fit: 1, thermogel_air: -3, premium_plus: -3, premium: -3 },
      mittel: { wellness: 2, aqua: 2, fit: 2, polargel: 2, thermogel_air: -2, premium_plus: -2, premium: -2 },
      ueber1000: { thermogel_air: 2, premium_plus: 2, premium: 2 },
      qualitaet: { thermogel_air: 2, premium_plus: 1 }
    }
  };

  /* Reason chips shown above the recommendation. A chip appears when the
     winning model earned >= 2 points from that answer. */
  var REASON_LABELS = {
    'position:seite': 'Gut für Seitenschläfer',
    'position:ruecken': 'Stützt den Rücken',
    'position:bauch': 'Fest genug für Bauchschläfer',
    'position:wechselnd': 'Für wechselnde Schlafpositionen',
    'feel:weich': 'Weiches Liegegefühl',
    'feel:mittel': 'Ausgewogenes Liegegefühl',
    'feel:fest': 'Festes Liegegefühl',
    'feel:unsicher': 'Zwei Härtegrade zum Ausprobieren',
    'complaints:ruecken': 'Entlastet bei Rückenschmerzen',
    'complaints:druck': 'Nimmt Druck von Schulter und Hüfte',
    'complaints:schwitzen': 'Wirkt nächtlichem Schwitzen entgegen',
    'budget:bis700': 'Passt in Ihr Budget',
    'budget:mittel': 'Starkes Preis-Leistungs-Verhältnis'
  };

  /* Tie-break order: earlier key wins on equal score. */
  var TIE_ORDER = ['premium', 'premium_plus', 'thermogel_air', 'wellness', 'fit', 'aqua', 'polargel', 'ortho'];

  function track(event, payload) {
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push(Object.assign({ event: event }, payload || {}));
    }
  }

  function readStorage() {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY));
    } catch (e) {
      return null;
    }
  }

  function writeStorage(state) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {
      /* private mode — the round-trip fallback voucher panel covers this */
    }
  }

  function MattressFinder(root) {
    this.root = root;
    this.stage = root.querySelector('[data-mf-stage]');
    this.questions = {};
    STEPS.forEach(function (step) {
      this.questions[step] = root.querySelector('[data-mf-question="' + step + '"]');
    }, this);
    this.gate = root.querySelector('[data-mf-screen="gate"]');
    this.result = root.querySelector('[data-mf-screen="result"]');
    this.progress = root.querySelector('[data-mf-progress]');
    this.progressLabel = root.querySelector('[data-mf-progress-label]');
    this.progressFill = root.querySelector('[data-mf-progress-fill]');
    this.backButton = root.querySelector('[data-mf-back]');
    this.cards = root.querySelector('[data-mf-cards]');

    this.answers = { who: null, position: null, feel: null, complaints: [], budget: null };
    this.recommendation = null;
    this.subscribed = false;

    this.bind();
    this.restore();
  }

  MattressFinder.prototype.bind = function () {
    var self = this;

    STEPS.forEach(function (step) {
      var question = self.questions[step];
      if (!question) return;
      var multi = question.dataset.mfType === 'multi';
      question.querySelectorAll('.mf-option').forEach(function (option) {
        option.addEventListener('click', function () {
          if (multi) {
            self.toggleMulti(question, option);
          } else {
            self.answerSingle(step, question, option);
          }
        });
      });
      var next = question.querySelector('[data-mf-next]');
      if (next) {
        next.addEventListener('click', function () {
          self.answers[step] = self.collectMulti(question);
          self.advanceFrom(step);
        });
      }
    });

    if (this.backButton) {
      this.backButton.addEventListener('click', function () {
        self.goBack();
      });
    }

    var gateForm = this.gate ? this.gate.querySelector('form') : null;
    if (gateForm) {
      gateForm.addEventListener('submit', function () {
        self.prepareSubmit();
      });
    }

    var skip = this.root.querySelector('[data-mf-skip]');
    if (skip) {
      skip.addEventListener('click', function () {
        track('mf_skip_gate');
        self.showResult(false);
      });
    }

    var toGate = this.root.querySelector('[data-mf-to-gate]');
    if (toGate) {
      toGate.addEventListener('click', function () {
        self.showScreen('gate');
      });
    }

    var restart = this.root.querySelector('[data-mf-restart]');
    if (restart) {
      restart.addEventListener('click', function () {
        self.reset();
      });
    }

    this.root.querySelectorAll('[data-mf-copy]').forEach(function (button) {
      button.addEventListener('click', function () {
        var code = self.root.dataset.voucherCode || '';
        if (navigator.clipboard && code) {
          navigator.clipboard.writeText(code).then(function () {
            button.textContent = 'Kopiert!';
            window.setTimeout(function () {
              button.textContent = 'Kopieren';
            }, 2000);
          });
        }
      });
    });
  };

  /* ---------- Flow ---------- */

  MattressFinder.prototype.restore = function () {
    var params = new URLSearchParams(window.location.search);
    var stored = readStorage();
    var hasErrors = !!this.root.querySelector('.mf-gate__error');

    this.stage.hidden = false;

    if (params.get('mf') === 'subscribed' || params.get('customer_posted') === 'true') {
      params.delete('mf');
      params.delete('customer_posted');
      var query = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (query ? '?' + query : ''));
      if (stored && stored.recommendation) {
        this.answers = stored.answers;
        this.recommendation = stored.recommendation;
        track('mf_subscribed', { mf_model: stored.recommendation.primary });
        this.showResult(true);
        return;
      }
      /* Subscribed, but quiz state is gone (other device / cleared
         storage): show the voucher anyway and let them start fresh. */
      var orphan = this.root.querySelector('[data-mf-orphan-voucher]');
      if (orphan) orphan.hidden = false;
      this.showStep(0);
      return;
    }

    if (hasErrors && stored && stored.recommendation) {
      this.answers = stored.answers;
      this.recommendation = stored.recommendation;
      this.showScreen('gate');
      return;
    }

    track('mf_start');
    this.showStep(0);
  };

  MattressFinder.prototype.answerSingle = function (step, question, option) {
    question.querySelectorAll('.mf-option').forEach(function (o) {
      o.classList.toggle('is-selected', o === option);
    });
    this.answers[step] = option.dataset.value;

    /* Child path: the sole Kinder & Jugend model is the answer — skip
       the adult questions and go straight to the gate. */
    if (step === 'who' && option.dataset.value === 'kind') {
      this.finishQuiz();
      return;
    }

    var self = this;
    window.setTimeout(function () {
      self.advanceFrom(step);
    }, 220);
  };

  MattressFinder.prototype.toggleMulti = function (question, option) {
    var exclusive = option.dataset.value === 'nichts';
    var pressed = option.getAttribute('aria-pressed') === 'true';
    if (exclusive && !pressed) {
      question.querySelectorAll('.mf-option').forEach(function (o) {
        o.setAttribute('aria-pressed', 'false');
        o.classList.remove('is-selected');
      });
    } else if (!exclusive) {
      var none = question.querySelector('.mf-option[data-value="nichts"]');
      if (none) {
        none.setAttribute('aria-pressed', 'false');
        none.classList.remove('is-selected');
      }
    }
    option.setAttribute('aria-pressed', String(!pressed));
    option.classList.toggle('is-selected', !pressed);
  };

  MattressFinder.prototype.collectMulti = function (question) {
    return Array.prototype.map.call(
      question.querySelectorAll('.mf-option[aria-pressed="true"]'),
      function (o) { return o.dataset.value; }
    );
  };

  MattressFinder.prototype.advanceFrom = function (step) {
    var index = STEPS.indexOf(step);
    if (index < STEPS.length - 1) {
      this.showStep(index + 1);
    } else {
      this.finishQuiz();
    }
  };

  MattressFinder.prototype.finishQuiz = function () {
    this.recommendation = this.computeResult();
    writeStorage({ answers: this.answers, recommendation: this.recommendation });
    track('mf_complete', { mf_model: this.recommendation.primary });
    this.prepareSubmit();
    this.showScreen('gate');
  };

  MattressFinder.prototype.prepareSubmit = function () {
    if (!this.recommendation) return;
    var tags = this.root.querySelector('[data-mf-tags]');
    if (tags) {
      var extra = ['mf-empfehlung-' + this.recommendation.primary];
      if (this.answers.budget) extra.push('mf-budget-' + this.answers.budget);
      tags.value = 'newsletter, matratzen-finder, ' + extra.join(', ');
    }
    writeStorage({ answers: this.answers, recommendation: this.recommendation });
  };

  MattressFinder.prototype.goBack = function () {
    var visible = this.currentStepIndex();
    if (this.gate && !this.gate.hidden) {
      /* From the gate, return to the last question that was asked. */
      var last = this.answers.who === 'kind' ? 0 : STEPS.length - 1;
      this.showStep(last);
      return;
    }
    if (visible > 0) this.showStep(visible - 1);
  };

  MattressFinder.prototype.currentStepIndex = function () {
    for (var i = 0; i < STEPS.length; i++) {
      var q = this.questions[STEPS[i]];
      if (q && !q.hidden) return i;
    }
    return -1;
  };

  MattressFinder.prototype.reset = function () {
    this.answers = { who: null, position: null, feel: null, complaints: [], budget: null };
    this.recommendation = null;
    this.root.querySelectorAll('.mf-option').forEach(function (o) {
      o.classList.remove('is-selected');
      if (o.hasAttribute('aria-pressed')) o.setAttribute('aria-pressed', 'false');
    });
    this.showStep(0);
  };

  /* ---------- Screens ---------- */

  MattressFinder.prototype.hideAll = function () {
    STEPS.forEach(function (step) {
      if (this.questions[step]) this.questions[step].hidden = true;
    }, this);
    if (this.gate) this.gate.hidden = true;
    if (this.result) this.result.hidden = true;
  };

  MattressFinder.prototype.showStep = function (index) {
    this.hideAll();
    var question = this.questions[STEPS[index]];
    if (!question) return;
    question.hidden = false;
    question.classList.remove('is-entering');
    void question.offsetWidth;
    question.classList.add('is-entering');

    this.progress.hidden = false;
    this.progressLabel.textContent = 'Frage ' + (index + 1) + ' von ' + STEPS.length;
    this.progressFill.style.width = ((index + 1) / STEPS.length * 100) + '%';
    this.backButton.hidden = index === 0;
  };

  MattressFinder.prototype.showScreen = function (name) {
    this.hideAll();
    this.progress.hidden = true;
    var screen = name === 'gate' ? this.gate : this.result;
    if (!screen) return;
    screen.hidden = false;
    screen.classList.remove('is-entering');
    void screen.offsetWidth;
    screen.classList.add('is-entering');
    this.backButton.hidden = name !== 'gate';
    if (name === 'gate') {
      var email = screen.querySelector('input[type="email"]');
      if (email && !email.value) email.focus();
    }
  };

  /* ---------- Scoring ---------- */

  MattressFinder.prototype.availableModels = function () {
    var models = {};
    this.cards.querySelectorAll('.mf-card').forEach(function (card) {
      models[card.dataset.mfModel] = card.dataset.available === 'true';
    });
    return models;
  };

  MattressFinder.prototype.computeResult = function () {
    var models = this.availableModels();
    var eligible = Object.keys(models).filter(function (key) { return models[key]; });

    /* ORTHO-CARE only comes in single-bed sizes. */
    if (this.answers.who === 'zwei') {
      eligible = eligible.filter(function (key) { return key !== 'ortho'; });
    }

    if (this.answers.who === 'kind') {
      var child = eligible.indexOf('ortho') !== -1 ? 'ortho' : eligible[0];
      return { primary: child, backup: null, reasons: ['Für Kinder und Jugendliche entwickelt'], child: true };
    }

    var scores = {};
    eligible.forEach(function (key) { scores[key] = 0; });

    var self = this;
    function apply(dimension, value) {
      var weights = WEIGHTS[dimension] && WEIGHTS[dimension][value];
      if (!weights) return;
      Object.keys(weights).forEach(function (key) {
        if (key in scores) scores[key] += weights[key];
      });
    }

    apply('who', this.answers.who);
    apply('position', this.answers.position);
    apply('feel', this.answers.feel);
    (this.answers.complaints || []).forEach(function (value) {
      apply('complaints', value);
    });
    apply('budget', this.answers.budget);

    var ranked = eligible.slice().sort(function (a, b) {
      if (scores[b] !== scores[a]) return scores[b] - scores[a];
      return TIE_ORDER.indexOf(a) - TIE_ORDER.indexOf(b);
    });

    var primary = ranked[0] || null;
    var backup = ranked[1] || null;

    /* Reason chips: answers that contributed >= 2 points to the winner. */
    var reasons = [];
    function collect(dimension, value) {
      var weights = WEIGHTS[dimension] && WEIGHTS[dimension][value];
      if (weights && weights[primary] >= 2) {
        var label = REASON_LABELS[dimension + ':' + value];
        if (label && reasons.indexOf(label) === -1) reasons.push(label);
      }
    }
    collect('position', this.answers.position);
    collect('feel', this.answers.feel);
    (this.answers.complaints || []).forEach(function (value) {
      collect('complaints', value);
    });
    if (this.answers.budget === 'bis700' && primary === 'ortho') reasons.push(REASON_LABELS['budget:bis700']);
    if (this.answers.budget === 'mittel' && WEIGHTS.budget.mittel[primary] >= 2) reasons.push(REASON_LABELS['budget:mittel']);

    return { primary: primary, backup: backup, reasons: reasons.slice(0, 3), child: false };
  };

  /* ---------- Result rendering ---------- */

  MattressFinder.prototype.showResult = function (subscribed) {
    if (!this.recommendation || !this.recommendation.primary) {
      this.recommendation = this.computeResult();
    }
    var rec = this.recommendation;
    if (!rec.primary) return;

    var voucher = this.result.querySelector('[data-mf-voucher]');
    var nudge = this.result.querySelector('[data-mf-voucher-nudge]');
    if (voucher) voucher.hidden = !subscribed;
    if (nudge) nudge.hidden = subscribed;

    var heading = this.result.querySelector('[data-mf-result-heading]');
    if (heading) {
      heading.textContent = rec.child
        ? 'Unsere Empfehlung für Ihr Kind'
        : 'Diese Matratze passt zu Ihnen';
    }

    var reasons = this.result.querySelector('[data-mf-reasons]');
    if (reasons) {
      reasons.innerHTML = '';
      (rec.reasons || []).forEach(function (label) {
        var li = document.createElement('li');
        li.textContent = label;
        reasons.appendChild(li);
      });
    }

    this.mountCard(rec.primary, this.result.querySelector('[data-mf-primary]'));
    var backupWrap = this.result.querySelector('[data-mf-backup-wrap]');
    if (rec.backup) {
      backupWrap.hidden = false;
      this.mountCard(rec.backup, this.result.querySelector('[data-mf-backup]'));
    } else {
      backupWrap.hidden = true;
    }

    this.showScreen('result');
    this.backButton.hidden = true;
    track('mf_result_view', { mf_model: rec.primary, mf_subscribed: !!subscribed });
  };

  MattressFinder.prototype.mountCard = function (key, slot) {
    if (!slot) return;
    slot.innerHTML = '';
    var card = this.cards.querySelector('.mf-card[data-mf-model="' + key + '"]');
    if (!card) return;
    var clone = card.cloneNode(true);
    var media = clone.querySelector('.mf-card__media');
    if (media) {
      media.removeAttribute('tabindex');
      media.removeAttribute('aria-hidden');
    }
    slot.appendChild(clone);
  };

  /* ---------- Init ---------- */

  function init(scope) {
    (scope || document).querySelectorAll('[data-mattress-finder]').forEach(function (root) {
      if (root.dataset.mfInitialized) return;
      root.dataset.mfInitialized = 'true';
      new MattressFinder(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
